import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';

@Component({
  selector: 'app-modal-change-image-comment',
  templateUrl: './modal-change-image-comment.component.html',
  styles: [
  ]
})
export class ModalChangeImageCommentComponent extends ExcTranslation implements OnInit, AfterViewInit {
  @Input() data: any;

  @ViewChild('commentInput', {read: ElementRef}) commentInput!: ElementRef;

  comment = '';
  inputWasEmpty = true;

  constructor(
    private modal: ExgModalService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.comment && this.data.comment !== ''){
      this.comment = this.data.comment;
      this.inputWasEmpty = false;
    }
  }

  ngAfterViewInit(): void {
    if (this.commentInput) {
      (this.commentInput.nativeElement.children[0].children[0]).focus();
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modal.close();
  }

  save(): void {
    if (this.comment && this.comment.length > 0) {
      this.modal.action({comment: this.comment});
    }
  }
}
